import { useCallback } from 'react';
import notificationService from '../services/notificationService';

export const useNotifications = () => {
  const success = useCallback((title: string, message: string, duration?: number) => {
    return notificationService.success(title, message, duration);
  }, []);

  const error = useCallback((title: string, message: string, duration?: number) => {
    return notificationService.error(title, message, duration);
  }, []);

  const warning = useCallback((title: string, message: string, duration?: number) => {
    return notificationService.warning(title, message, duration);
  }, []);

  const info = useCallback((title: string, message: string, duration?: number) => {
    return notificationService.info(title, message, duration);
  }, []);

  const notice = useCallback((title: string, message: string, duration?: number) => {
    return notificationService.notice(title, message, duration);
  }, []);

  const remove = useCallback((id: string) => {
    notificationService.removeNotification(id);
  }, []);

  const clearAll = useCallback(() => {
    notificationService.clearAllNotifications();
  }, []);

  const getNotifications = useCallback(() => {
    return notificationService.getNotifications();
  }, []);

  const getUnreadCount = useCallback(() => {
    return notificationService.getUnreadCount();
  }, []);

  const setSystemNotificationsEnabled = useCallback((enabled: boolean) => {
    notificationService.setSystemNotificationsEnabled(enabled);
  }, []);

  const isSystemNotificationsEnabled = useCallback(() => {
    return notificationService.isSystemNotificationsEnabled();
  }, []);

  return {
    success,
    error,
    warning,
    info,
    notice,
    remove,
    clearAll,
    getNotifications,
    getUnreadCount,
    setSystemNotificationsEnabled,
    isSystemNotificationsEnabled
  };
};
